<div
    class="mp-recent-activity-card trezo-card mb-25 border-radius d-block bg-white border-0 shadow-none"
    [class.component-rtl-enabled]="themeService.isRTLEnabled()"
>
    <div class="trezo-card-header d-flex align-items-center justify-content-between">
        <div class="trezo-card-title">
            <h5 class="mb-0">
                Recent Activity
            </h5>
        </div>
    </div>
    <div class="trezo-card-content">
        <ul class="list ps-0 pe-0 mt-0 mb-0 list-unstyled position-relative">
            <li class="position-relative">
                <div class="time d-block">
                    Just now
                </div>
                <span class="title text-black d-block fw-medium">
                    Weekly Stand-Up Meetings:
                </span>
                <p>
                    We continued our weekly stand-up meetings where team members provided updates on their current tasks, discussed any roadblocks, and coordinated efforts for the week ahead.
                </p>
                <span class="author d-block">
                    By: <span class="text-primary">Olivia Rodriguez</span>
                </span>
            </li>
            <li class="position-relative">
                <div class="time d-block">
                    1 day ago
                </div>
                <span class="title text-black d-block fw-medium">
                    Project Kickoff Session:
                </span>
                <p>
                    The session included introductions, a review of project goals and objectives, and initial planning discussions.
                </p>
                <span class="author d-block">
                    By: <span class="text-primary">Isabella Cooper</span>
                </span>
            </li>
            <li class="position-relative">
                <div class="time d-block">
                    2 days ago
                </div>
                <span class="title text-black d-block fw-medium">
                    Team Building Workshop:
                </span>
                <p>
                    Last Friday, we conducted a team building workshop focused on improving communication and collaboration among team members. Activities included team challenges, icebreakers, and open discussions.
                </p>
                <span class="author d-block">
                    By: <span class="text-primary">Lucas Morgan</span>
                </span>
            </li>
            <li class="position-relative">
                <div class="time d-block">
                    3 days ago
                </div>
                <span class="title text-black d-block fw-medium">
                    Lunch and Learn Session:
                </span>
                <p>
                    We organized a lunch and learn session on March 15th where a guest speaker from the industry discussed emerging trends in our field. It was an insightful session that sparked valuable discussions among team members.
                </p>
                <span class="author d-block">
                    By: <span class="text-primary">Ethan Parker</span>
                </span>
            </li>
        </ul>
    </div>
</div>